module.exports = __webpack_public_path__ + "img/4.a7ae9329.png";